module.exports = __webpack_public_path__ + "img/settingsicon.c7c97aeb.jpg";